import axios from 'axios';
import { useDispatch } from 'react-redux';

// For Local
//export const BASE_URL = 'https://localhost:44389/'
//export const BASE_URL = 'https://sandbox.planetcp.com/CMS-Backend/'
  
// For Live
// ----------------------------export const BASE_URL = 'https://planetxpro.planetcp.com/APIServer/'
// export const BASE_URL = 'https://dxpanalytics.rkfoodland.com/APIServer/'

// Sandbox
// export const BASE_URL = 'https://dxpanalytics.rkfoodland.com/APIServerSandbox/'

// export const BASE_URL = 'https://sandbox.planetcp.com/Lozen-Pharma/'

//For CICD
export const BASE_URL = process.env.REACT_APP_API_URL;


// Helper function to check if cookies are available
export const isCookieAvailable = (cookieName) => {
  if (typeof document === 'undefined') return false;
  return document.cookie.split(';').some(c => c.trim().startsWith(`${cookieName}=`));
};

// Helper function to get token from localStorage as fallback
export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // Always send cookies when available
});


instance.interceptors.request.use(request => {
  // Always check for token in localStorage as fallback for incognito/cookie-blocked scenarios
  // Backend returns Token in response body, which we store in localStorage
  const token = getAuthToken();
  
  // Check if cookie is available (primary method)
  const cookieAvailable = isCookieAvailable('auth_token');
  
  // If cookie is not available OR we have a token in localStorage, use Authorization header
  // This ensures we always send auth when cookies are blocked (incognito mode)
  if (!cookieAvailable && token) {
    // Add token to Authorization header as fallback when cookies are blocked
    request.headers.Authorization = `Bearer ${token}`;
    console.log('[API Interceptor] Using Authorization header (cookie blocked or unavailable)');
  } else if (cookieAvailable) {
    // Cookie is available, backend will read it automatically
    // But we can also send Authorization header as backup if backend supports both
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
  }
  
  return request;
});


instance.interceptors.response.use(
  response => {
    // Backend returns Token in response.data.Token (as per backend code)
    // Backend also sets HttpOnly cookie (which JavaScript cannot read - this is by design for security)
    // Store token in localStorage as fallback for incognito/cookie-blocked scenarios
    if (response.data?.Token) {
      const token = response.data.Token;
      localStorage.setItem('auth_token', token);
      // Note: HttpOnly cookies cannot be detected via document.cookie, so we always store in localStorage
      // This is expected behavior and ensures authentication works in all scenarios
    } else if (response.data?.auth_token || response.data?.AuthToken) {
      // Fallback for other possible field names
      const token = response.data.auth_token || response.data.AuthToken;
      localStorage.setItem('auth_token', token);
    }
    
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Clear localStorage token on 401
      localStorage.removeItem('auth_token');
      console.log('[API Interceptor] Cleared auth_token from localStorage due to 401');
      
      // Redirect to login page on 401 unauthorized
      // Only redirect if we're not already on login page
      if (typeof window !== 'undefined' && window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;

